export function generateApiParams(params: { [key: string]: any }): { [key: string]: any } {
  return Object.keys(params).reduce((acc, key) => {
    if (params[key]) {
      acc[key] = params[key];
    }

    return acc;
  }, {} as { [key: string]: any });
}
